var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-subtle"
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s((_vm.value || '') + '.')
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.model)
    },
    on: {
      "focus": function($event) {
        _vm.show = 1
      },
      "blur": function($event) {
        _vm.show = 0
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [(_vm.show) ? _c('span', {
    staticClass: "inp-actions"
  }, [_c('button', {
    staticClass: "btn-reset fragment-type",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.convertToLiteral
    }
  }, [_vm._v("+")])]) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebc136e2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueText.vue
// module id = 85
// module chunks = 1